export default function (file) {
  this.name = file ? file.name : null;
  this.blobFile = file ? file.blobFile : null;
}